/** Coming back to the tab only refetches when the forecast is older than this. */
export const AGENDA_WEATHER_STALE_MS = 5 * 60 * 1000;
export const AGENDA_WEATHER_POLL_MS = 10 * 60 * 1000;

/**
 * A refresh for the date already on screen runs in the background: the current
 * forecast stays visible and is replaced only when the new one arrives.
 */
export function isAgendaWeatherBackgroundRefresh(
  loadedDate: string | null,
  requestedDate: string
): boolean {
  return loadedDate === requestedDate;
}

export function shouldRefreshAgendaWeather(
  lastFetchedAtMs: number | null,
  nowMs: number,
  staleMs = AGENDA_WEATHER_STALE_MS
): boolean {
  return lastFetchedAtMs == null || nowMs - lastFetchedAtMs >= staleMs;
}
